import { render, staticRenderFns } from "./ResultsDispute.vue?vue&type=template&id=47420b68&scoped=true&"
import script from "./ResultsDispute.vue?vue&type=script&lang=js&"
export * from "./ResultsDispute.vue?vue&type=script&lang=js&"
import style0 from "./ResultsDispute.vue?vue&type=style&index=0&id=47420b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47420b68",
  null
  
)

export default component.exports